import theme from '../../css/appTheme.js';

import {
    Collapse,
    List,
    ListItemButton,
    ListItemText,
    Button,
    Stack,
    Typography,
    Box,
    Tooltip,
    Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
    CircularProgress
} from "@mui/material";
import {useEffect, useState, useMemo} from "react";
import {ExpandLess, ExpandMore} from "@mui/icons-material";
import {getCount, getJobHours} from "../../serverREST";
import {useDispatch, useSelector} from "react-redux";
import {deleteJob, pushJob} from "../../redux/jobsSlice";

import {deleteJobFromTextSearchJobs} from "../../redux/listsSlice";
import {StarRate as StarRateIcon, Delete as DeleteIcon} from '@mui/icons-material';

/*
import AddCircleIcon from '@mui/icons-material/AddCircle';
*/
const treeListStyle = {
    listItemSx: {},
    nestedListSx: {pl: 1, pr: 0},
    itemSx: {p: 0, pr: 1, pl: 0},
};

function JobButton(props) {
    const jobs = useSelector(state => state.jobs.jobs);
    const sdhHourPrice = useSelector(state => state.settings.sdhHourPrice)
    const [btnJobLoad, setBtnJobLoad] = useState(false)
    const dispatch = useDispatch();

    const getJobIndex = (operation) => {
        return jobs.findIndex((job) => job.job_id === operation.job_id);
    };

    const handleClick = (job) => {
        const currentIndex = getJobIndex(job);

        if (currentIndex === -1) {
            setBtnJobLoad(true);

            getJobHours(job.job_id, (resp) => {
                console.log('props', props);
                console.log('job', job);

                const newJob = {
                    ...props.item, // system, super_system
                    job_id: job.job_id,
                    detail: job.detail,
                    operation: {
                        operation_id: job.operation_id,
                        operation_name: job.operation_name,
                    },
                    hourPrice: sdhHourPrice,
                    difficulty: 1,
                    sdh_hour: resp.data[0].sdh_hour,
                    other: job.other,
                };

                //   console.log('newJob', newJob);
                dispatch(pushJob(newJob));
                getCount();
            })

        } else {
            dispatch(deleteJob(currentIndex));
        }
    };
    const hasInJobs = getJobIndex(props.item) >= 0;

   useEffect(()=>{
       if(hasInJobs) setBtnJobLoad(false);
   },[hasInJobs])

    if (btnJobLoad) {
        return (<Button
            variant='outlined'
            size='small'
            sx={{
                m: '2px', flexGrow: 1,
                '&:hover': {backgroundColor: theme.palette.primary.main + '20'},
            }}
            disabled={true}
        >
            <CircularProgress color="inherit" size={20} sx={{marginRight:"10px"}}/>
            <Typography variant='body2' fontSize={13}>
                {props.item.operation_name}
            </Typography>
        </Button>);
    }
    if (props.item.custom) {
        return (
            <Box display="flex" alignItems="center">
                <Tooltip title={props.item.owned ? `Собственный норматив` : `Дружественный норматив`}>
                    <Button
                        key={props.item.job_id}
                        variant='outlined'
                        size='small'
                        sx={{
                            m: '2px', flexGrow: 1,
                            '&:hover': {backgroundColor: theme.palette.primary.main + '20'},
                        }}
                        style={{pointerEvents: 'all'}}
                        onClick={() => handleClick(props.item)}
                        className={hasInJobs ? 'Mui-disabled' : ''}
                    >
                        <Box style={{
                            "display": "flex",
                            "gap": "6px",
                            "alignItems": "center"
                        }}>
                            {
                                props.item.owned ? <StarRateIcon fontSize="small" color="secondary"/> :
                                    <Box style={{
                                        "padding": "0px 2px",
                                        "backgroundColor": `#${props.item.user_code}`,
                                        "color": "white",
                                        "alignItems": "center",
                                        "display": "flex",
                                        "borderRadius": "2px"
                                    }}>
                                        <Typography variant='body2' fontSize={13}>
                                            {props.item.user_num}
                                        </Typography>
                                    </Box>
                            }

                            <Typography variant='body2' fontSize={13}>
                                {props.item.operation_name}
                            </Typography>
                        </Box>
                    </Button>
                </Tooltip>
                {
                    props.item.owned ?
                        <>
                            <Tooltip title="Удалить норматив">
                                <DeleteIcon fontSize="small" color="secondary"
                                            onClick={() => props.actionDelete(props.item)}
                                />
                            </Tooltip>

                        </> : null}
            </Box>

        );
    }
    /*
    *  <Tooltip title="Указать систему">
                                <AddCircleIcon fontSize="medium"
                                               color="secondary"
                                               onClick={() => {
                                                   console.log("Указать систему")
                                               }}
                                />
                            </Tooltip>*/
    return (
        <Button
            key={props.item.job_id}
            variant='outlined'
            size='small'
            sx={{
                m: '2px', flexGrow: 1,
                '&:hover': {backgroundColor: theme.palette.primary.main + '20'},
            }}
            style={{pointerEvents: 'all'}}
            onClick={() => handleClick(props.item)}
            className={hasInJobs ? 'Mui-disabled' : ''}
        >
            <Typography variant='body2' fontSize={13}>
                {props.item.operation_name}
            </Typography>
        </Button>

    )
}

function DetailBlock(props) {
    const [open, setOpen] = useState(false);
    const handleClick = () => {
        setOpen(!open);
    };
    return (
        <div>
            <ListItemButton onClick={handleClick} sx={{...treeListStyle.listItemSx}}>
                <ListItemText primary={props.index}/>
                {open ? <ExpandLess/> : <ExpandMore/>}
            </ListItemButton>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding sx={treeListStyle.nestedListSx}>
                    <ListItemButton
                        disableTouchRipple
                        sx={{...treeListStyle.itemSx, pb: 1}}>
                        <Box sx={{minWidth: '100%'}}>
                            <Stack direction="row" flexWrap="wrap">
                                {props.item.map((item, index) => (
                                    <JobButton
                                        key={index}
                                        item={item}
                                        actionDelete={props.actionDelete}
                                    />

                                ))}
                            </Stack>
                        </Box>
                    </ListItemButton>
                </List>
            </Collapse>
        </div>
    )
}

function SystemBlock(props) {
    const [open, setOpen] = useState(false);
    const handleClick = () => {
        setOpen(!open);
    };
    return (
        <div>
            <ListItemButton onClick={handleClick} sx={{...treeListStyle.listItemSx}}>
                <ListItemText primary={props.index}/>
                {open ? <ExpandLess/> : <ExpandMore/>}
            </ListItemButton>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding sx={treeListStyle.nestedListSx}>
                    {Object.entries(props.system.jobs)
                        .sort(([keyA], [keyB]) => keyA.localeCompare(keyB, "ru", {sensitivity: "base"}))
                        .map(([index, item]) => (
                            <DetailBlock
                                item={item}
                                key={index}
                                index={index}
                                actionDelete={props.actionDelete}
                            />
                        ))}
                </List>
            </Collapse>
        </div>
    )
}

function SuperSystemBlock(props) {
    const [open, setOpen] = useState(false);
    const handleClick = () => {
        setOpen(!open);
    };
    return (
        <div>
            <ListItemButton onClick={handleClick} sx={treeListStyle.listItemSx}>
                <ListItemText
                    primary={props.index}/>
                {open ? <ExpandLess/> : <ExpandMore/>}
            </ListItemButton>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding sx={treeListStyle.nestedListSx}>
                    {Object.entries(props.superSystem)
                        .sort(([keyA], [keyB]) => keyA.localeCompare(keyB, "ru", {sensitivity: "base"}))
                        .map(([index, system]) => {
                            return (
                                <SystemBlock
                                    system={system}
                                    key={index}
                                    index={index}
                                    actionDelete={props.actionDelete}
                                />
                            )
                        })}
                </List>
            </Collapse>
        </div>
    )
}

export default function TreeList() {
    const [deleteAlertJob, setDeleteAlertJob] = useState(null);
    const dispatch = useDispatch();
    const jobs = useSelector(state => state.lists.carJobs);
    const order = [
        "Двигатель",
        "Трансмиссия",
        "Подвеска",
        "Рулевое управление",
        "Тормоза",
        "Кондиционер, отопление, вентиляция",
        "Система пассивной безопасности (SRS)",
        "DAS / Системы помощи водителю",
        "Кузов - электрооборудование",
        "Кузов - элементы",
        "Собственные нормативы"
    ];
    const handleDeleteJob = (job) => {
        dispatch(deleteJobFromTextSearchJobs(job.job_id));
    }
    const superSystems = useMemo(() => {
        if (!jobs?.length) return {};
        return jobs.reduce((acc, item) => {
            const keySuperSystem = item.super_system != null && item.super_system_id !== 1
                ? item.super_system[0].toUpperCase() + item.super_system.slice(1)
                : 'Собственные нормативы';

            if (!acc?.[keySuperSystem]) acc[keySuperSystem] = {};
            if (!acc?.[keySuperSystem]?.[item.system]) acc[keySuperSystem][item.system] = {
                jobs: {}
            };
            const partName = item.other ? `${item.part_name} (${item.other})` : item.part_name;
            if (!acc[keySuperSystem][item.system].jobs?.[partName]) {
                acc[keySuperSystem][item.system].jobs[partName] = [];
            }
            acc[keySuperSystem][item.system].jobs[partName].push(
                {
                    detail: {part_id: item.part_id, part_name: item.part_name},
                    job_id: item.job_id,
                    operation_id: item.operation_id,
                    operation_name: item.operation,
                    other: item.other || "",
                    user_code: item.user_code || "",
                    user_num: item.user_num || "",
                    custom: item.custom || false,
                    owned: item.owned
                }
            );
            return acc;
        }, {});
    }, [jobs])
    return (
        <div>
            <List
                sx={{m: 1, bgcolor: 'background.paper'}}
                component="nav"
                aria-labelledby="list-subheader"
            >
                {Object.entries(superSystems)
                    .sort(([keyA], [keyB]) => {
                            const idxA = (order.indexOf(keyA) === -1 ? (order.indexOf("Собственные нормативы") - 0.5) : order.indexOf(keyA));
                            const idxB = (order.indexOf(keyB) === -1 ? (order.indexOf("Собственные нормативы") - 0.5) : order.indexOf(keyB));
                            return idxA - idxB;
                        }
                    )
                    .map(([index, superSystem]) => (
                        <SuperSystemBlock
                            key={index}
                            index={index}
                            superSystem={superSystem}
                            actionDelete={setDeleteAlertJob}
                        />
                    ))}
            </List>
            <Dialog
                open={deleteAlertJob !== null}
                onClose={() => setDeleteAlertJob(null)}
            >
                <DialogTitle>
                    {'Удалить норматив?'}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {deleteAlertJob
                            ? `Вы выбрали работу "${deleteAlertJob.detail.part_name} ${deleteAlertJob.operation_name}" для удаления`
                            : ''
                        }
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => {
                        handleDeleteJob(deleteAlertJob);
                        setDeleteAlertJob(null);
                    }}>
                        {'Удалить'}
                    </Button>
                    <Button onClick={() => setDeleteAlertJob(null)}>
                        {'Отмена'}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}
